import { useMemo } from 'react'

type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night'

const greetings: Record<TimeOfDay, string[]> = {
  morning: [
    'Good morning!',
    'Rise and shine!',
    'Top of the morning!',
    'Hello there, early bird!',
    'Good morning, sunshine!',
  ],
  afternoon: ['Good afternoon!', 'Hello!', 'Hey there!', 'Greetings!', 'Welcome back!'],
  evening: ['Good evening!', 'Evening!', 'Hello, night owl!', 'Welcome this evening!', 'Hey there, friend!'],
  night: ['Working late?', 'Burning the midnight oil?', 'Good evening!', 'Still awake?', 'Hello, night owl!'],
}

const supportingPhrases = [
  "Let's optimize your approach.",
  "Let's make progress together.",
  "Let's solve something together.",
  "Let's turn your ideas into reality.",
  "Let's find answers together.",
]

const getTimeOfDay = (currentHour?: number): TimeOfDay => {
  const hour = currentHour ?? new Date().getHours()

  if (hour >= 5 && hour < 12) return 'morning'
  if (hour >= 12 && hour < 17) return 'afternoon'
  if (hour >= 17 && hour < 21) return 'evening'
  return 'night'
}

const randomItem = <T,>(items: T[]): T => {
  if (items.length === 0) {
    throw new Error('Cannot select from empty phrase list')
  }
  return items[Math.floor(Math.random() * items.length)]!
}

const useMaxEmptyStatePhrases = () => {
  return useMemo(() => {
    const timeOfDay = getTimeOfDay()

    return {
      greeting: randomItem(greetings[timeOfDay]),
      supportingPhrase: randomItem(supportingPhrases),
    }
  }, [])
}

export default useMaxEmptyStatePhrases
